import React from 'react';
import { Typography, Grid } from '@mui/material';
import { CellData } from './cellData.dumb';
import { Question } from './voms.domain';
import { Label } from '../modules.interface';
import { useCustomTranslation } from '../../../../../../translation/customTranslation';

interface RowDataProps {
  question: Question;
  setResponse: any;
  data?: Label;
}
export function RowData({ question, setResponse, data }: RowDataProps) {
  const { t } = useCustomTranslation('assessment');

  const saveAnswersResponse = (
    key: string,
    value: number | boolean | string,
  ) => {
    setResponse(question?.rowId, key, value);
  };

  return (
    <Grid display="flex" alignContent="center">
      <Grid
        item
        sx={{ p: 1, mt: 1, textAlign: 'center' }}
        xs={12}
        sm={12}
        md={4}
        lg={4}
      >
        <Typography variant="subtitle2">{t(question.key)}</Typography>
      </Grid>
      <CellData
        assessmentQuestion={question}
        onSave={saveAnswersResponse}
        data={data}
      />
    </Grid>
  );
}
